module.exports = __webpack_public_path__ + "static/media/custom-10000-low.ede16163.png";